import { ThunkAction } from "redux-thunk";

import { Patient } from "lib/build/patients";

import { api } from "src/common/utils/api";
import {
	createGenericError,
	NotificationsAction
} from "src/features/notifications";

export type PatientAction =
	| FetchPatientStart
	| FetchPatientSuccess
	| FetchPatientFailure;

interface FetchPatientStart {
	type: "FETCH_PATIENT_START";
	payload: { patientId: string };
}

interface FetchPatientSuccess {
	type: "FETCH_PATIENT_SUCCESS";
	payload: { patientId: string; patient: Patient };
}

interface FetchPatientFailure {
	type: "FETCH_PATIENT_FAILURE";
	payload: { patientId: string; error: unknown };
}

interface FetchPatientOptions {
	org: string;
	mod: string;
	patientId: string;
}

export function fetchPatient({
	org,
	mod,
	patientId
}: FetchPatientOptions): ThunkAction<
	Promise<void>,
	unknown,
	void,
	PatientAction | NotificationsAction
> {
	return async dispatch => {
		dispatch({ type: "FETCH_PATIENT_START", payload: { patientId } });
		try {
			const { data: patient } = await api.get<Patient>(
				`/patients/${patientId}?organization=${org}&module=${mod}`
			);
			dispatch({
				type: "FETCH_PATIENT_SUCCESS",
				payload: { patientId, patient }
			});
		} catch (error) {
			dispatch({
				type: "FETCH_PATIENT_FAILURE",
				payload: { patientId, error }
			});
			dispatch(createGenericError());
		}
	};
}
